import { useCallback } from 'react';
import { findElement } from '~/utils/dom';
import { useRootSiteTemplatesQuery } from '~/libs/gql/queries/root_site_templates/rootSiteTemplatesQuery.generated';
import { urlValidator } from '~/utils/forms';
import type { FieldApi } from 'react-form';

const PAGINATION_LIMIT = 12;

export const useSiteInformationStep = () => {
  const { data, fetchMore } = useRootSiteTemplatesQuery({
    variables: {
      isOnboardingTemplate: true,
      pagination: {
        limit: PAGINATION_LIMIT,
        offset: 0,
        sortBy: 'createdAt',
      },
      templateType: 'indie',
    },
  });

  const getScrollParent = useCallback(() => findElement<HTMLDivElement>('div div[role="dialog"]'), []);

  const handleLoadMore = useCallback(() => {
    if (!data?.rootSiteTemplates) return;

    void fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newRecords = [
          ...previousResult.rootSiteTemplates.records,
          ...fetchMoreResult.rootSiteTemplates.records,
        ];

        const newResults = fetchMoreResult;
        newResults.rootSiteTemplates.records = newRecords;

        return newResults;
      },
      variables: {
        isOnboardingTemplate: true,
        pagination: {
          limit: PAGINATION_LIMIT,
          offset: data.rootSiteTemplates.offset + PAGINATION_LIMIT,
          sortBy: 'createdAt',
        },
      },
    });
  }, [fetchMore, data?.rootSiteTemplates]);

  const handleValidateUrl = useCallback(async (value: string, field: FieldApi<string>) => {
    const result = await urlValidator(value, field);

    if (result !== false) {
      return `${result} (example.com | https://example.com)`;
    }

    return false;
  }, []);

  return {
    data,
    getScrollParent,
    handleLoadMore,
    handleValidateUrl,
  };
};
